import axios from "axios";

// ---------------------------------------------------------------------------
// Resolve a URL base da API dinamicamente conforme o domínio de execução.
//
// Regra de produção (múltiplos subdomínios sob HTTPS):
//   Front-end:   https://chatbot.nialab.com.br
//   Back-end:    https://api.chatbot.nialab.com.br
// Como o front e o back estão em subdomínios diferentes, a URL base do axios
// e do redirect do Google OAuth precisa apontar de forma ABSOLUTA para o
// subdomínio da API. Em qualquer outro host (dev, preview, staging futuro),
// caímos no fallback via REACT_APP_BACKEND_URL.
// ---------------------------------------------------------------------------
function resolveBackendUrl() {
  if (typeof window !== "undefined") {
    var host = window.location.hostname;
    if (host === "chatbot.nialab.com.br") {
      return "https://api.chatbot.nialab.com.br";
    }
  }
  return process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";
}

export const BACKEND_URL = resolveBackendUrl();
export const API_URL = `${BACKEND_URL}/api`;

// URL do login Google — sempre absoluta e apontando para o subdomínio da API.
export const GOOGLE_LOGIN_URL = `${API_URL}/auth/google/login`;

// Logo assets — servidos localmente pelo bundle do React (public/assets/).
// Assim o app não depende de nenhum CDN externo em produção.
export const NIA_LOGO_URL = "/assets/logo-nia.png";
export const BOT_LOGO_URL = "/assets/bot.png";

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nia_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("nia_token");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/chatbot/")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
